@if (loginError()) {
  <app-alert alertType="error">
    {{ 'login.errors.generic_login_error'| translate }}
  </app-alert>
}

<app-button [label]="'login.login_link_text' | translate"
            [fullWidth]="true"
            class="tw-mt-spacing-500"
            (clicked)="logIn()"/>
